import { VuiStat } from "../../../lib";

export const Stat = () => {
  return <VuiStat title="Latency" text="67ms" />;
};
